import request from '@/utils/request'

/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
export function getOssConfig (configId) {
  return request({
    url: '/common/get-cos-signature',
    method: 'get'
  })
}

export function getOssOSSConfig (configId) {
  return request({
    url: '/common/get-oss-signature',
    method: 'get'
  })
}


// export function getTenCosConfig (configId) {
//   return request({
//     url: '/common/get-vueOss-signature',
//     method: 'get'
//   }).then(function (res) {
//     return res.data;
//   })
// }

// 全局变量，用于存储CDN域名
let cdnDomainCache = null;

export function getTenCosConfig() {
  return request({
    url: '/common/get-vueOss-signature',
    method: 'get'
  }).then(function (res) {
    // 如果返回的是对象（包含signature和cdnDomain），提取signature字段并保存CDN域名
    if (typeof res.data === 'object' && res.data.signature) {
      cdnDomainCache = res.data.cdnDomain; // 保存CDN域名
      return res.data.signature;
    }
    // 如果返回的是字符串（向后兼容），直接返回
    return res.data;
  })
};

// 获取CDN域名
export function getCdnDomain() {
  return cdnDomainCache;
};
